import {EventEmitter, Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventService {
  changeObjectNameEvent = new EventEmitter<string>();
  disableBodyScrollbar = new EventEmitter<boolean>();
  updateMainThumbnail = new EventEmitter<any>();
  duplicateBuildiung = new EventEmitter<boolean>();
  chooseRegionEvent = new EventEmitter<number>();
  confirmForFlats = new EventEmitter<boolean>();
  openRegionMap = new EventEmitter<boolean>();
  closeGallery = new EventEmitter<boolean>();
  countObject = new EventEmitter();
  buildingID = new EventEmitter<number>();
  initialize = new EventEmitter();
  subject = new Subject<any>();
  invest = new EventEmitter();
  count = new EventEmitter<number>();

  constructor() { }

  sendChanges(change: boolean) {
    this.subject.next(change);
  }

  getChanges(): Observable<any> {
    return this.subject.asObservable();
  }

  getColorByDeviationTypeID(id: number): string[] {
    switch (id) {
      case 0: return ['green', '#12381B', '#078C09'];
      case 1: return ['yellow', '#524920', '#F1CC31'];
      case 2: return ['red', '#560B11', '#FF0000'];
      case 3: return ['grey', 'grey', 'grey'];
      default: break;
    }
  }

  getMonthName(index: number, isShortName?: boolean, isUpperCase?: boolean) {
    if (!index) return ;
    let months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
    let month: string = '';
    if (isShortName) {
      month = months[index - 1].substring(0, 3);
    } else {
      month = months[index - 1];
    }
    if (isUpperCase) {
      return month.toUpperCase();
    } else {
      return month;
    }
  }

}
